module.exports = __webpack_public_path__ + "img/46.c9f91ae3.svg";